import { render, staticRenderFns } from "./UserSettingInfo.vue?vue&type=template&id=85fda388&scoped=true&"
import script from "./UserSettingInfo.vue?vue&type=script&lang=js&"
export * from "./UserSettingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fda388",
  null
  
)

export default component.exports